<template>
<div>
    <b-row>
        <b-col md="12" class="my-1">
            <h3 class="text-themecolor">FM Module rapportage</h3>
        </b-col>
    </b-row>
    <b-row>
        <b-col md="12">
            <div class="card">
                <div class="card-body">
                    <!-- User Interface controls -->
                    <b-row>
                        <b-col md="12" class="my-1">
                            <b-form-group class="mb-0">
                                <b-input-group>
                                    <b-form-input v-model="filter" placeholder="Zoeken.." ref='search' />
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <!-- User Interface controls -->

                    <!-- Main table element -->
                    <b-row>
                        <b-col md="12">
                            <b-table class="table-hover" show-empty :items="processeddocuments" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" @filtered="onFiltered">
                                <template v-slot:cell(fixedCosts)="data">{{ data.item.fixedCosts | currency }}</template>
                                <template v-slot:cell(price)="data">{{ data.item.price | currency }}</template>
                                <template v-slot:cell(expendableCosts)="data">{{ data.item.expendableCosts | currency }}</template>
                                <template v-slot:cell(totalCosts)="data">{{ data.item.totalCosts | currency }}</template>
                            </b-table>
                        </b-col>
                    </b-row>
                    <!-- Main table element -->

                    <!-- Pagination controls -->
                    <b-row>
                        <b-col md="12" lg="5">
                            <b-form-group label-cols :label="$t('fmweb.aantalItems')" label-size="sm" label-align="left">
                                <b-form-select :options="pageOptions" v-model="perPage" />
                            </b-form-group>
                        </b-col>
                        <b-col md="12" lg="7">
                            <b-pagination :total-rows="count" :per-page="perPage" v-model="currentPage" class="my-0 pull-right" />
                        </b-col>
                    </b-row>
                    <!-- Pagination controls -->
                </div>
            </div>
        </b-col>
    </b-row>
</div>
</template>

<script>
//Import store
import {
    mapGetters,
    mapActions
} from 'vuex'

//Import command
import Command from './command'

export default {
    name: `report-index`,
    data() {
        return {
            command: {},
            fields: [{
                    key: 'companyId',
                    label: 'KlantID',
                    sortable: true
                },
                {
                    key: 'name',
                    label: 'Naam',
                    sortable: true
                },
                {
                    key: 'subscription',
                    label: 'Abonnement',
                    sortable: true
                },
                {
                    key: 'invoiceType',
                    label: 'Facturatie type(n)',
                    sortable: true
                },
                {
                    key: 'fixedCosts',
                    label: 'Vaste kosten'
                },
                {
                    key: 'totalUse',
                    label: 'Totaal verbruik'
                },
                {
                    key: 'variableUseInvoiceScan',
                    label: 'Verbruik Scan'
                },
                {
                    key: 'variableUseProcessedInvoice',
                    label: 'Verbruik Factuur'
                },
                {
                    key: 'variableUseAttachementScan',
                    label: 'Verbruik Bijlage'
                },
                {
                    key: 'price',
                    label: 'Tarief'
                },
                {
                    key: 'expendableCosts',
                    label: 'Verbruikskosten'
                },
                {
                    key: 'totalCosts',
                    label: 'Totale kosten'
                }
            ],
            currentPage: 1,
            perPage: 50,
            pageOptions: [50, 100, 200],
            filter: null,
            count: 0
        }
    },
    computed: {
        ...mapGetters ('fm', ['processeddocuments']),
    },
    methods: {
        ...mapActions('fm', ['all', 'create', 'update', 'delete']),
        onFiltered(filteredItems) {
            this.count = filteredItems.length;
            this.currentPage = 1
        },
        loadModal(item) {
            let vm = this;
            vm.$store.dispatch('errors/clearErrors');
            vm.command = new Command(item);
        },
        onSubmit(event) {
            event.preventDefault();
            let vm = this;

            let payload = {
                resource: 'price-agreements',
                path: vm.$route.path,
                params: vm.command
            };

            let action = vm.command.id ? vm.update(payload) : vm.create(payload);
            action.then(() => {
                
            })
        }
    },
    created() {
        let vm = this;
        vm.all({
            resource: 'processeddocuments'
        })
    }
}
</script>
